import React from 'react';
export function Compare() {
  const rows = [{
    label: 'Documentación clínica',
    bad: 'Fichas incompletas o en papel',
    good: 'Historia clínica completa desde el primer turno'
  }, {
    label: 'Respaldo legal',
    bad: 'Sin consentimientos firmados',
    good: '6 consentimientos listos, Ley 26.529'
  }, {
    label: 'Asistente',
    bad: 'Improvisa porque nadie le explicó',
    good: 'Manual completo + protocolos escritos'
  }, {
    label: 'Emergencias',
    bad: 'Sin protocolo, nadie sabe qué hacer',
    good: '6 emergencias con pasos claros y visibles'
  }, {
    label: 'Seguimiento',
    bad: 'Pacientes que no vuelven sin saber por qué',
    good: '5 plantillas de WhatsApp y sistema de reactivación'
  }, {
    label: 'Economía',
    bad: 'Sin registro, sin control, sin saber cuánto ganaste',
    good: 'Planilla de ingresos y los 5 indicadores clave'
  }, {
    label: 'Vacaciones',
    bad: 'Imposible desconectarse',
    good: 'El consultorio funciona sin que estés presente'
  }];
  return <section className="bg-white px-5 py-10 md:py-[70px] text-center" data-id="element-31">
      <div className="mx-auto max-w-[780px]" data-id="element-32">
        <h2 className="mb-6 md:mb-[44px] font-bebas text-[clamp(28px,5vw,50px)] text-navy" data-id="element-33">
          ¿Cuánto cuesta NO tenerlo?
        </h2>

        <div className="overflow-hidden rounded-xl border-[1.5px] border-brandGray-light" data-id="element-34">
          <div className="grid grid-cols-2 bg-navy p-[16px_20px] sm:grid-cols-3" data-id="element-35">
            <span className="hidden font-montserrat text-[13px] font-extrabold uppercase tracking-[1px] text-white sm:block" data-id="element-36"></span>
            <span className="font-montserrat text-[13px] font-extrabold uppercase tracking-[1px] text-white" data-id="element-37">
              Sin el Kit
            </span>
            <span className="font-montserrat text-[13px] font-extrabold uppercase tracking-[1px] text-gold" data-id="element-38">
              Con el Kit
            </span>
          </div>

          {rows.map((row, i) => <div key={i} className={`grid grid-cols-2 items-center border-b border-brandGray-light p-[14px_20px] sm:grid-cols-3 ${i % 2 !== 0 ? 'bg-offWhite' : 'bg-white'}`} data-id="element-39">
              <span className="hidden text-[13px] leading-relaxed text-brandText sm:block" data-id="element-40">
                {row.label}
              </span>
              <span className="text-[13px] font-semibold leading-relaxed text-[#dc3545]" data-id="element-41">
                {row.bad}
              </span>
              <span className="text-[13px] font-bold leading-relaxed text-[#198754]" data-id="element-42">
                {row.good}
              </span>
            </div>)}
        </div>
      </div>
    </section>;
}